import jwtDecode from 'jwt-decode';
import { USER_ORG, OTP_TOKEN, JWT_TOKEN } from 'shared/constants/SharedConstants';
import { s1SessionStorage } from 's1-service-ui-components';
/* eslint class-methods-use-this: 0 */

const tokenPrefix = 'Bearer ';

class AuthenticationHelper {
  isJwtTokenStored() {
    const jwtToken = sessionStorage.getItem(JWT_TOKEN);
    return (
      jwtToken && 
      jwtToken !== '' &&
      jwtToken.length > tokenPrefix.length
    );
  }

  getJwtToken() {
    return (this.isJwtTokenStored()) ? sessionStorage.getItem(JWT_TOKEN) : null;
  }

  storeJwtToken(jwtToken) {
    jwtToken.indexOf(tokenPrefix) >= 0 
      ? jwtToken = jwtToken.replace(tokenPrefix, '') 
      : '';
    jwtToken !== 'Bearer' && jwtToken !== tokenPrefix && jwtToken !== '' 
      ? sessionStorage.setItem(JWT_TOKEN, jwtToken) 
      : '';
    return null;
  }

  removeJwtToken() {
    sessionStorage.removeItem(JWT_TOKEN);
    return null;
  }

  hasJwtPayloadKey(key) {
    if (this.isJwtTokenStored()) {
      const decodedToken = jwtDecode(sessionStorage.getItem(JWT_TOKEN));
      if (!key) {
        return null;
      }
      return decodedToken[key] !== undefined;
    }
    return null;
  }

  getValueFromJwtPayload(key) {
    if (this.isJwtTokenStored) {
      const decodedToken = jwtDecode(sessionStorage.getItem(JWT_TOKEN));
      if (!key) {
        return null;
      }
      return decodedToken[key];
    }
    return null;
  }

  getDecodedToken() {
    return (this.isJwtTokenStored()) ? jwtDecode(sessionStorage.getItem(JWT_TOKEN)) : null;
  }

  getHeaders(url) {
    const storedContext = this.getContext();
    const contextId = storedContext ? storedContext.id : s1SessionStorage.getS1Context();
    let headers = {
      Authorization:
        url && url.includes('/otp-login')
          ? this.getOtpToken()
          : this.isJwtTokenStored()
            ? tokenPrefix + this.getJwtToken()
            : '',
      //TODO: Research and apply solution for webpack build (options: workaround)
      ['x-app-id']: 'UTM' //eslint-disable-line no-useless-computed-key
    };
    headers['x-utm-selected-org'] = contextId;
    headers['x-request-context'] = contextId;
    return headers;
  }

  getJwtTokenAuthHeader() {
    return tokenPrefix + this.getJwtToken();
  }

  storeOtpToken(otpToken) {
    sessionStorage.setItem(OTP_TOKEN, otpToken);
    return null;
  }

  getOtpToken() {
    return tokenPrefix + sessionStorage.getItem(OTP_TOKEN);
  }

  isContextStored() {
    return (sessionStorage.getItem(USER_ORG) && sessionStorage.getItem(USER_ORG) !== '');
  }

  getContext() {
    return this.isContextStored() ? JSON.parse(sessionStorage.getItem(USER_ORG)) : null;
  }
}
export default new AuthenticationHelper();



// WEBPACK FOOTER //
// ./src/shared/helpers/authenticationHelper.js